import { combineReducers } from "redux";
import {
    CLEAR_COMPANIES,
    GET_COMPANIES_ERROR,
    GET_COMPANIES_START,
    GET_COMPANIES_SUCCESS,
} from "../actions/company";
import {
    GET_ORDERS_ERROR,
    GET_ORDERS_START,
    GET_ORDERS_SUCCESS,
} from "../actions/orders";
import {
    GET_COMPANY_PRODUCTS_ERROR,
    GET_COMPANY_PRODUCTS_START,
    GET_COMPANY_PRODUCTS_SUCCESS,
} from "../actions/products";
import { CompanyProductInterface } from "../interfaces/search";

interface GetCompanyProductsPayload {
    products: Array<CompanyProductInterface>;
}

export type CompanyProductsAction =
    | { type: typeof GET_COMPANY_PRODUCTS_START }
    | {
          type: typeof GET_COMPANY_PRODUCTS_SUCCESS;
          payload: GetCompanyProductsPayload;
      }
    | { type: typeof GET_COMPANY_PRODUCTS_ERROR };

export interface ClosingDates {
    closing_date: string;
    is_consolidated: boolean;
    number_of_months: number;
    year: number;
}

interface CompanyProductsState {
    products: Array<CompanyProductInterface>;
    name?: string;
    piva?: string;
    fiscal_code?: string;
    postal_code?: string;
    address?: string;
    city?: string;
    rea?: any;
    province?: string;
    closing_dates?: Array<ClosingDates>;
    isGettingCompanyProducts: boolean;
}

const initialStateCompanyProducts: CompanyProductsState = {
    products: [],
    isGettingCompanyProducts: false,
};

interface GetCompaniesPayload {
    input: any;
    records: any;
    total_records: number;
}

export type CompaniesAction =
    | { type: typeof GET_COMPANIES_START }
    | { type: typeof GET_COMPANIES_SUCCESS; payload: GetCompaniesPayload }
    | { type: typeof GET_COMPANIES_ERROR }
    | { type: typeof CLEAR_COMPANIES };

interface CompaniesState {
    input: any;
    records: any;
    total_records: number;
    isGettingCompanies: boolean;
}

const initialState: CompaniesState = {
    input: null,
    records: [],
    total_records: 0,
    isGettingCompanies: false,
};

interface GetOrdersPayload {
    data: any;
}
export type OrdersAction =
    | { type: typeof GET_ORDERS_START }
    | { type: typeof GET_ORDERS_SUCCESS; payload: GetOrdersPayload }
    | { type: typeof GET_ORDERS_ERROR };

interface OrdersState {
    data: any;
    isGettingOrders: boolean;
}

const initialStateOrders: OrdersState = {
    data: [],
    isGettingOrders: false,
};

const companies = (state = initialState, action: CompaniesAction) => {
    switch (action.type) {
        case GET_COMPANIES_START:
            return {
                ...initialState,
                isGettingCompanies: true,
            };
        case GET_COMPANIES_SUCCESS:
            return {
                ...initialState,
                ...action.payload,
                isGettingCompanies: false,
            };
        case GET_COMPANIES_ERROR:
        case CLEAR_COMPANIES:
            return initialState;
        default:
            return state;
    }
};

const products = (
    state = initialStateCompanyProducts,
    action: CompanyProductsAction,
) => {
    switch (action.type) {
        case GET_COMPANY_PRODUCTS_START:
            return {
                ...initialStateCompanyProducts,
                isGettingCompanyProducts: true,
            };
        case GET_COMPANY_PRODUCTS_SUCCESS:
            return {
                ...initialStateCompanyProducts,
                ...action.payload,
                isGettingCompanyProducts: false,
            };
        case GET_COMPANY_PRODUCTS_ERROR:
            return initialStateCompanyProducts;
        default:
            return state;
    }
};

const orders = (state = initialStateOrders, action: OrdersAction) => {
    switch (action.type) {
        case GET_ORDERS_START:
            return {
                ...initialStateOrders,
                isGettingOrders: true,
            };
        case GET_ORDERS_SUCCESS:
            return {
                ...initialStateOrders,
                data: action.payload,
                isGettingOrders: false,
            };
        case GET_ORDERS_ERROR:
            return initialStateOrders;
        default:
            return state;
    }
};

const search = combineReducers({ companies, products, orders });

export default search;
